import {
    TransactionDetailRow,
    TransactionFeeSection,
    TransactionDialogContent,
    TransactionSection,
    TokenAmount,
} from "@/components";
import { useClaimRedemptionTransaction } from "@/hooks";
import { TOKEN_IDS } from "@/types";
import { Divider } from "@/components";
import { useCallback } from "react";

export interface ClaimTransactionProps {
    redeemAmount: number;
    onClose?: () => void;
}

export function ClaimRedemption({ redeemAmount, onClose }: ClaimTransactionProps) {
    const { gasPriceUSD, executeClaimTransaction, isLoading } = useClaimRedemptionTransaction();

    const handleConfirm = useCallback(async () => {
        try {
            await executeClaimTransaction();
            onClose?.();
        } catch (e) {
            console.error("Error executing claim transaction:", e);
        }
    }, [executeClaimTransaction, onClose]);

    const CONFIRM_TEXT = "Confirm Claim";
    const RECEIVE_TEXT = <TokenAmount amount={redeemAmount} tokenId={TOKEN_IDS.USDC} size="md" />;

    return (
        <TransactionDialogContent
            isLoading={isLoading}
            onClose={onClose}
            onConfirm={handleConfirm}
            confirmText={CONFIRM_TEXT}
            className="min-w-sm w-[420px]"
        >
            <TransactionSection>
                <TransactionDetailRow label="Receive" value={RECEIVE_TEXT} />
            </TransactionSection>
            <Divider />
            <TransactionFeeSection gasPriceUSD={gasPriceUSD} />
        </TransactionDialogContent>
    );
}
